import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Components
import Header from '../../components/Header';
import Title from '../../components/Title';

// Images
import RfactorIcon from '../../assets/images/rfactorIcon.png';
import ArmaIcon from '../../assets/images/armaIcon.png';

// Tabelas
import { DataGrid, ColDef, ValueFormatterParams } from '@material-ui/data-grid';

// Ícones material-ui
import { Details, InsertDriveFile, Close, CloudDownload } from '@material-ui/icons';
import {
    Tooltip, IconButton, Snackbar, List, ListItem, ListItemText, ListItemIcon, ListItemSecondaryAction,
    Typography, Drawer, Divider, Button
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

// Firebase
import { db, storage } from '../../utils/firebaseConfig';

// Context
import AuthContext from '../../Context/context';

function ModsAtivos() {
    let params: any = useParams();

    const { isAdmin } = useContext(AuthContext);

    const [mods, setMods] = useState<any>([]);
    const [mod, setMod] = useState<any>(null);
    const [timeUpdated, setTimeUpdated] = useState('');

    // Drawer
    const [openDrawerRight, setOpenDrawerRight] = useState(false);
    const showDrawerRight = () => setOpenDrawerRight(true);
    const hideDrawerRight = () => setOpenDrawerRight(false);

    // Alert's
    const [alert, setAlert] = useState('');
    const [openAlert, setShowAlert] = useState(false);

    const showAlert = () => setShowAlert(true);
    const hideAlert = () => setShowAlert(false);

    useEffect(() => {
        GetModsAtivos();
    }, [])

    const GetModsAtivos = () => {
        let collection = '';

        if (params.jogo === 'rfactor')
            collection = 'ModsAtivosRfactor'
        else if (params.jogo === 'arma')
            collection = 'ModsAtivosArma'
        else {
            setAlert('Esta coleção de mods não existe. Por favor, corrija o nome da coleção do mod na URL.')
            return showAlert();
        }

        db.collection(collection).onSnapshot(resp => {
            resp.docs.map((m: any) => {
                // Define o horario que foi atualizado o documento
                setTimeUpdated(new Date(m.data().timeUpdated.toDate()).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }))

                // Faz um map na lista de modsAtivos para aparecer na lista
                let mds = m.data().modsAtivos.map((mAt: any) => {
                    return {
                        id: mAt.id,
                        nome: mAt.nome,
                        enviadoPor: mAt.enviadoPor,
                        categoria: mAt.categoria,
                        timeUpdated: mAt.timeUpdated,
                        downloadUrl: mAt.downloadUrl
                    }
                })

                setMods(mds);
            });

        })
    }

    const DownloadMod = async (url: any) => {
        // Cria um link
        let fileLink = document.createElement('a');

        // Adiciona no href a url de download do arquivo
        fileLink.href = url;

        fileLink.target = "_blank";

        // função de 'click' no link para envia-lo a página de download do mod
        fileLink.click();
    }

    const columns: ColDef[] = [
        { field: 'nome', headerName: 'Nome do Mod', width: 320 },
        { field: 'enviadoPor', headerName: 'Enviado por', width: 320 },
        {
            field: 'actions',
            headerName: 'Ações',
            width: 170,
            disableClickEventBubbling: true,
            renderCell: (params: ValueFormatterParams) => (
                <div style={{ margin: '0 auto' }}>
                    <Tooltip title="Download" onClick={() => { DownloadMod(params.row.downloadUrl) }}>
                        <IconButton>
                            <CloudDownload />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Ver Detalhes" onClick={() => {
                        setMod(params.row);
                        showDrawerRight();
                    }}>
                        <IconButton>
                            <Details />
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];

    return (
        <div>
            <Header />
            {
                params.jogo === 'rfactor' &&
                <Title img={RfactorIcon} title='Mods rodando atualmente no servidor de rFactor 2' />
            }
            {
                params.jogo === 'arma' &&
                <Title img={ArmaIcon} title='Mods rodando atualmente no servidor de Arma 2' />
            }

            <div style={{ marginTop: '3em' }}>
                <div className="table-container" style={{ height: 500, margin: '0 auto' }}>
                    <DataGrid pagination rows={mods} columns={columns} pageSize={5} rowsPerPageOptions={[5, 10, 25, 50]}
                    />
                </div>
            </div>

            <p style={{ textAlign: 'center', marginBottom: '2em' }}>
                <small>Estes são os mods rodando atualmente no servidor. Baixe todos que você não tem para conseguir entrar!</small>
            </p>

            <Snackbar open={openAlert} autoHideDuration={12000} onClose={hideAlert}>
                <Alert onClose={hideAlert} severity="error" variant="filled">
                    {alert}
                </Alert>
            </Snackbar>

            <Drawer anchor="right" open={openDrawerRight} onClose={() => {
                hideDrawerRight();
                setMod(null);
            }}>
                {
                    mod !== null &&
                    <List style={{ width: '20em' }}>
                        <ListItem style={{ margin: '1.5em 0' }}>
                            <ListItemIcon>
                                <InsertDriveFile />
                            </ListItemIcon>
                            <Typography component="h5" variant="h5">
                                {mod.nome.length > 14 ? mod.nome.substring(0, 14) + '...' : mod.nome}
                            </Typography>
                            <ListItemSecondaryAction style={{ display: 'flex', alignItems: 'center' }} >
                                <IconButton onClick={() => {
                                    hideDrawerRight();
                                    setMod(null);
                                }}>
                                    <Close />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <ListItemText
                                primary="Nome"
                                secondary={mod.nome.length > 20 ? mod.nome.substring(0, 20) + '...' : mod.nome}
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemText
                                primary="Categoria do Mod"
                                secondary={mod.categoria}
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemText
                                primary="Criado"
                                secondary={new Date(mod.timeUpdated.toDate()).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })}
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemText
                                primary="Enviado por"
                                secondary={mod.enviadoPor}
                            />
                        </ListItem>
                    </List>
                }
            </Drawer>
        </div>
    );
}

export default ModsAtivos;
